import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../shared/Modal';
import { UX2 } from '@wsb/guac-widget-core';
import { mapContextToProps } from '../OlsShopContext';

const styles = {
  textBlockStyle: {
    margin: 'large'
  },
  submitButton: {
    marginTop: 'small',
    marginBottom: 'medium'
  },
  headerStyle: {
    textAlign: 'center',
    paddingBottom: 'medium'
  }
};

export class TextOnlyModal extends React.Component {
  get content() {
    const { Text, DisplayHeading, Block } = UX2.Element;
    const { Form } = UX2.Group;
    const translate = this.props.translate;

    const title = translate('coming_soon_modal.title');
    const line_1 = translate('coming_soon_modal.content.line_1');
    const line_2 = translate('coming_soon_modal.content.stay_tuned');
    const buttonLabel = translate('coming_soon_modal.ok');

    return (
      <React.Fragment>
        <DisplayHeading style={ styles.headerStyle } children={ title } />
        <Block style={ styles.textBlockStyle }>
          <Text children={ line_1 } />
          <Text children={ line_2 } />
        </Block>

        <Form action='#' onSubmit={ this.props.closeModal }>
          <UX2.Element.Button.Primary
            size='small'
            type='submit'
            style={ styles.submitButton }
            children={ buttonLabel }
          />
        </Form>
      </React.Fragment>
    );
  }

  render() {
    return (
      <Modal renderMode={ this.props.renderMode } closeModal={ this.props.closeModal }>
        { this.content }
      </Modal>
    );
  }
}

TextOnlyModal.propTypes = {
  renderMode: PropTypes.string,
  closeModal: PropTypes.func,
  translate: PropTypes.func
};

TextOnlyModal.defaultProps = {
  translate: () => {}
};

export default mapContextToProps(TextOnlyModal, context => ({
  translate: context.translate
}));
